import { connect } from 'react-redux';
import Actions from '../../Actions/Creators';
import HSGHeader from './Component/HSGHeader';
import Phi from './../../Phi/Phi'
// import Dashboard from '../DashboardContainer/Component/Dashboard'

const mapStateToProps = (state, ownProps) => {
    const userRole =  Phi.User.roles()
    return {
    
        ...state,
        roleType: userRole && userRole.length && userRole[0].role_type_id,
        currentProgram: state.organization.currentProgram,    
        organization: state.organization.currentOrganization,
    // organization: JSON?.parse(sessionStorage?.getItem("currentOrganization")),
        programs: state.organization.programs
        
    }
}



const mapDispatchToProps = (dispatch) => {
    return {
      logoutUser: () => dispatch(Actions.logoutUser()), // Action to logout
      getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HSGHeader)



